import { useState, useEffect } from "react";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useToast } from "./Toast";
import { subscribe, reset } from "../features/subscription/subscrptionSlice";
import Loader from "./Loader";

function Footer() {
  const toast = useToast();
  const [email, setEmail] = useState("");

  const dispatch = useDispatch();

  const { isError, isLoading, isSuccess, message } = useSelector((state) => {
    return state.subscribe;
  });

  useEffect(() => {
    if (isError) {
      toast.error(message);
      setEmail("");
    }

    if (isSuccess) {
      toast.success(message);
      setEmail("");
    }
    dispatch(reset());
  }, [isError, isSuccess, email, message, dispatch, toast]);

  const onChange = (e) => {
    setEmail(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(
      subscribe({
        email: email,
      })
    );
  };

  return (
    <>
      <footer className="w-full bg-[#07090d] border-t border-white/5 pt-24 pb-12 px-6 relative overflow-hidden">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-purple-600/5 rounded-full blur-[100px]"></div>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20">
            {/* Brand Column */}
            <div className="flex flex-col gap-8">
              <Link to="/" className="flex items-center gap-3 group">
                <div className="w-12 h-12 bg-gradient-to-tr from-cyan-500 to-purple-600 rounded-2xl flex items-center justify-center text-black shadow-[0_0_15px_rgba(0,242,255,0.3)] group-hover:rotate-[360deg] transition-all duration-700">
                  <span className="font-black text-2xl">G</span>
                </div>
                <span className="font-black text-2xl text-white tracking-[0.2em] uppercase italic">
                  Gamer
                  <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-purple-600 ml-1">
                    Hub
                  </span>
                </span>
              </Link>
              <p className="text-gray-500 text-xs font-bold uppercase tracking-widest leading-loose max-w-xs">
                The apex of gaming commerce. High-performance gear, precision
                engineered for the elite. Experience the hardware revolution.
              </p>
            </div>

            {/* Shop Links */}
            <div className="flex flex-col gap-6">
              <h3 className="text-[10px] font-black text-cyan-500/50 uppercase tracking-[0.4em]">
                Quick Loot
              </h3>
              <div className="flex flex-col gap-4">
                {["PCs", "Consoles", "Controllers", "Headphones"].map(
                  (link) => (
                    <Link
                      key={link}
                      to={`/catalog?category=${link}`}
                      className="text-gray-400 hover:text-cyan-400 text-xs font-black uppercase tracking-widest transition-all hover:translate-x-2"
                    >
                      {link}
                    </Link>
                  )
                )}
              </div>
            </div>

            {/* Support Links */}
            <div className="flex flex-col gap-6">
              <h3 className="text-[10px] font-black text-purple-500/50 uppercase tracking-[0.4em]">
                Command Center
              </h3>
              <div className="flex flex-col gap-4">
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-purple-400 text-xs font-black uppercase tracking-widest transition-all hover:translate-x-2"
                >
                  Request Intel
                </Link>
                <Link
                  to="/my-orders"
                  className="text-gray-400 hover:text-purple-400 text-xs font-black uppercase tracking-widest transition-all hover:translate-x-2"
                >
                  Track Shipment
                </Link>
                <Link
                  to="/credits"
                  className="text-gray-400 hover:text-purple-400 text-xs font-black uppercase tracking-widest transition-all hover:translate-x-2"
                >
                  Pts Recharge
                </Link>
              </div>
            </div>

            {/* Newsletter */}
            <div className="flex flex-col gap-8">
              <div className="flex flex-col gap-3">
                <h3 className="text-xl font-black text-white italic tracking-tighter mb-6 uppercase">
                  Gamer<span className="text-cyan-400">Hub</span>
                </h3>
                <p className="text-xs text-gray-500 font-bold uppercase tracking-wider leading-relaxed">
                  Join the elite. Get notified of legendary drops and limited
                  builds.
                </p>
              </div>
              <form onSubmit={onSubmit} className="relative group">
                <input
                  type="email"
                  placeholder="IDENTITY@MAIL.COM"
                  value={email}
                  onChange={onChange}
                  className="w-full bg-white/5 border-2 border-white/10 rounded-2xl py-5 px-6 focus:border-cyan-400/50 transition-all outline-none text-xs font-black text-cyan-400 tracking-widest placeholder:text-gray-700"
                />
                <button
                  disabled={isLoading}
                  className="absolute right-3 top-1/2 -translate-y-1/2 w-12 h-12 bg-cyan-500 text-black rounded-xl flex items-center justify-center hover:bg-cyan-400 transition-all shadow-[0_0_15px_rgba(0,242,255,0.3)] disabled:opacity-50"
                >
                  {isLoading ? (
                    <Loader size="sm" />
                  ) : (
                    <FaArrowRight className="text-sm" />
                  )}
                </button>
              </form>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-8">
            <p className="text-[10px] font-black text-gray-600 uppercase tracking-[0.3em]">
              © 2026 GamerHub Labs. Protocol v1.0.4
            </p>
            <div className="flex gap-10 text-[10px] font-black text-gray-600 uppercase tracking-[0.3em]">
              <span className="cursor-pointer hover:text-cyan-400 transition-colors">
                Safety Protocol
              </span>
              <span className="cursor-pointer hover:text-purple-400 transition-colors">
                Terms of Use
              </span>
              <span className="cursor-pointer hover:text-white transition-colors">
                Network Cookies
              </span>
            </div>
          </div>
        </div>
      </footer>
      {/* Centralized ToastContainer in Header */}
    </>
  );
}

export default Footer;
